import ShipBobAuthentication from '@shipbob/auth'
import ShipbobAppSettings from '../appSettings/appSetting'

const localAuthInfo = {
  authority: ShipbobAppSettings.authUri,
  client_id: ShipbobAppSettings.authClient,
  post_logout_redirect_uri: `${location.protocol}//${location.host}/app/merchant/#/Login`,
  redirect_uri: `${location.protocol}//${location.host}/app/Merchant/signin-callback`,
  response_type: 'code',
  response_mode: 'query',
  scope: ShipbobAppSettings.authScopes
}

const authService = new ShipBobAuthentication(localAuthInfo)

export function getAuthService () {
  return authService
}
